import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/__generated__/DesignDetailsPopupQuery$parameters';
import type { DesignDetailsPopupQuery } from './src/ui/__generated__/DesignDetailsPopupQuery.graphql';

export const designDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			designDetailsPopup: DesignDetailsPopupQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-design-details-popup" */ './src/ui/DesignDetailsPopup.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			designDetailsPopup: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueAri: issueId,
				},
			},
		},
	}),
});
